import LogRule from './log.vue';

export default LogRule;
